import cn from 'classnames';

import VideoBox from '@src/components/VideoBox';
import Whiteboard from '@src/components/Whiteboard';

import { IVideoStream, TLayoutItems } from '@src/types';

import './VideosContainerScreen.scss';

interface IBigScreenProps {
  isWhiteboardActive: boolean;
  videoBox?: IVideoStream;
  isPipBox?: boolean;
  whiteboardWidth?: 'default' | 'full';
  selectedLayout?: TLayoutItems;
}

const BigScreen = ({ isWhiteboardActive, videoBox, isPipBox, whiteboardWidth, selectedLayout }: IBigScreenProps) => {
  return (
    <div className={cn('big-screen', { 'items-end': selectedLayout === 'BOTTOM_BAR' })}>
      {isWhiteboardActive ? (
        <Whiteboard width={whiteboardWidth} />
      ) : (
        videoBox && (
          <VideoBox
            {...videoBox}
            isPipBox={isPipBox}
            objectFit={videoBox.type === 'videoType' ? 'cover' : 'contain'}
            isBigScreen
          />
        )
      )}
    </div>
  );
};

export default BigScreen;
